import { BlockEnv, isEvalLikeEnv } from "./env-context";

export const isBlockAvailableInEnvironment = (blockType: string, env?: BlockEnv): boolean => {
  if (blockType === "Composition") {
    return env === BlockEnv.SMART_TABLE;
  }

  if (blockType === "Human") {
    return isEvalLikeEnv(env);
  }

  if (blockType === "Condition") {
    return env === BlockEnv.AGENT;
  }

  if (blockType === "Static") {
    return env === BlockEnv.AGENT;
  }

  return true;
};
